

"use client";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';

export default function ImageClickMe({ image = "", link = "" }: { image: any, link: any }) {
    return (
        <div className="mx-auto pt-8">
            <div className="relative w-full lg:mt-12">{link && (
                <div className="hidden lg:block absolute -right-8 -top-8 lg:-right-12 lg:-top-12 bg-lemone rounded-full p-2">
                    <motion.div className="w-[64px] h-[64px] md:w-[100px] md:h-[100px] relative  "
                        whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }}>
                        <motion.svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full" viewBox="0 0 100 100"
                            animate={{ rotate: 360 }}
                            transition={{ duration: 8, ease: "linear", repeat: Infinity }}
                        >
                            <defs>
                                <path id="circle"
                                    d="
M 50, 50
m -37, 0
a 37,37 0 1,1 74,0
a 37,37 0 1,1 -74,0"/>
                            </defs>
                            <text className="text-[16px] md:text-[17px] tracking-[.2em] lg:tracking-widest">
                                <textPath href="#circle">
                                    Live Site - Click Me  -
                                </textPath>
                            </text>
                        </motion.svg>
                        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                            <a href={link}
                                className="w-[34px] h-[34px] lg:h-[54px] lg:w-[54px] text-2xl md:text-[1.75rem] flex justify-center items-center bg-smoke text-neutral-100 rounded-full">
                                <FontAwesomeIcon icon={faEye} />
                            </a>
                        </div>
                    </motion.div>
                </div>
            )}
                {image ? (<img className='w-full lg:w-[720px] xl:w-[900px] 2xl:w-[800px] 3xl:w-[900px] 4xl:w-[1500px] h-full aspect-16/9 object-cover' src={`/assets/images/portfolio/${image}`} alt="" />
                ) : (<img
                    src="/assets/images/default.webp"
                    className="w-full h-full"
                    alt="Default Image"
                />
                )}
            </div>
        </div>
    );
} 